<mat-dialog-content>
    <div class="spinner-center" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngIf="!loading">
        <div class="div-row">
            <div class="title">
                <span *ngIf="data?.boudActionType === BoudActionTypes.CreateBoud">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CREATE.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="data?.boudActionType === BoudActionTypes.EditBoud">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.EDIT.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="data?.boudActionType === BoudActionTypes.ViewBoud">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.VIEW.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="boud?.name as name" class="ml5">{{name}}</span>
            </div>
            <div class="action-buttons">
                <button mat-raised-button
                    [color]="data?.boudActionType === BoudActionTypes.ViewBoud ? 'primary' : 'warn'"
                    (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>

                <button
                    *ngIf="data?.boudActionType === BoudActionTypes.CreateBoud || data?.boudActionType === BoudActionTypes.EditBoud"
                    mat-raised-button
                    [color]="data?.boudActionType === BoudActionTypes.EditBoud && boudStatus !== UDEU_BOUD_DRAFT_STATUS ? 'primary' : 'accent'"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.EDIT.DIALOG.TITLE' | translate | translate"
                    (click)="createBoud(true)"
                    [disabled]="boudStatus && boudStatus !== UDEU_BOUD_DRAFT_STATUS ? mainFormGroup.invalid : false">
                    <mat-icon>save</mat-icon>
                </button>

                <button mat-raised-button color="primary"
                    *ngIf="data?.boudActionType === BoudActionTypes.CreateBoud || (data?.boudActionType === BoudActionTypes.EditBoud && boudStatus === UDEU_BOUD_DRAFT_STATUS)"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CREATE.TITLE' | translate"
                    (click)="createBoud()" [disabled]="mainFormGroup.invalid">
                    <mat-icon>add_circle</mat-icon>
                </button>
            </div>
        </div>
        <mat-stepper #matStepper orientation="horizontal" [linear]="false" [selectedIndex]="selectedIndex">
            <ng-container *ngIf="udeuService.getStepsFiltered(steps) as stepsList">
                <ng-container *ngFor="let step of stepsList; let i = index">
                    <ng-container *ngIf="step.form.group as formGroup">
                        <mat-step #matStep [stepControl]="formGroup" *ngIf="!step.disabled"
                            [completed]="isCompleted(matStep)">
                            <form [formGroup]="formGroup">
                                <ng-template matStepperIcon="edit"><mat-icon>check</mat-icon></ng-template>
                                <ng-template matStepperIcon="number"><mat-icon>none</mat-icon></ng-template>
                                <ng-template matStepLabel><span [matTooltip]="step.name | translate">{{step.name |
                                        translate
                                        }}</span></ng-template>
                                <div class="formDiv">
                                    <ng-container *ngIf="step.type === StepTypes.GENERIC; else special">
                                        <ng-container *ngFor="let controlName of udeuService.getObjectKeys(formGroup)">
                                            <ng-container *ngIf="step.form.fields[controlName] as formField">
                                                <ng-container *ngIf="!formField.disabled">
                                                    <div *ngIf="formField.type === MatFormFieldType.INPUT"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-form-field class="w100">
                                                            <mat-label>{{formField.label | translate}}</mat-label>
                                                            <textarea matInput cdkTextareaAutosize
                                                                [placeholder]="formField.placeholder | translate"
                                                                [formControlName]="controlName"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                    <smt-date-input *ngIf="formField.type === MatFormFieldType.DATE"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        [group]="formGroup" [controlName]="controlName"
                                                        [placeholder]="formField.placeholder" [label]="formField.label"
                                                        (dateChanged)="udeuService.formFieldChangeFunc(formField, null)"
                                                        [dateType]="DateType.DATE"></smt-date-input>

                                                    <smt-search-select
                                                        *ngIf="(formField.type === MatFormFieldType.SELECT && formField.options?.length > 0) 
                                                            || (formField.type === MatFormFieldType.SELECT && formGroup.controls[controlName].value)"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        [group]="formGroup" [controlName]="controlName"
                                                        [label]="formField.label" [options]="formField.options"
                                                        [useChips] = "false"
                                                        (optionSelected)="udeuService.formFieldChangeFunc(formField, $event.option.value)"
                                                        (optionChanged)="udeuService.formFieldChangeFunc(formField, null)"></smt-search-select>

                                                    <div *ngIf="(formField.type === MatFormFieldType.SELECT_MULTIPLE && formField.options?.length > 0) 
                                                        || (formField.type === MatFormFieldType.SELECT_MULTIPLE && formGroup.controls[controlName].value)"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <smt-search-select [group]="formGroup"
                                                            [controlName]="controlName" [multiple]="true"
                                                            [label]="formField.label" [options]="formField.options"
                                                            [useChips] = "false"
                                                            (optionSelected)="udeuService.formFieldChangeFunc(formField, formGroup.get(controlName).value)"
                                                            (optionChanged)="udeuService.formFieldChangeFunc(formField, formGroup.get(controlName).value)"
                                                            (removedValue)="udeuService.formFieldChangeFunc(formField, formGroup.get(controlName).value)"></smt-search-select>
                                                    </div>

                                                    <span
                                                        *ngIf="formField.empty && (formField.type === MatFormFieldType.SELECT || formField.type === MatFormFieldType.SELECT_MULTIPLE)"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        class="empty-field">
                                                        <mat-form-field class="w100" color="warn">
                                                            <mat-label>{{ formField.label | translate}}</mat-label>
                                                            <input matInput disabled
                                                                [value]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.EMPTY_FIELD' | translate">
                                                        </mat-form-field>
                                                    </span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #special>
                                        <ng-container *ngIf="step.type === StepTypes.BOUD && !step.disabled">
                                            <alden-publication-info class="w100" [boud]="boud"
                                                [isManager]="isManager"></alden-publication-info>
                                        </ng-container>
                                        <ng-container *ngIf="step.type === StepTypes.DOCS_TO_TRANSFER">
                                            <boud-elements class="w100" [group]="elementsFormGroup"
                                                [disabled]="data.boudActionType != BoudActionTypes.CreateBoud && data.boudActionType != BoudActionTypes.EditBoud"
                                                [boud]="boud"
                                                [actionType]="elementActionTypes.UDEU_BOUD_MENTION_ACTION_TYPE"></boud-elements>
                                        </ng-container>
                                        <div *ngIf="step.type === StepTypes.FILES" class="content-div">
                                            <alden-attach-files class="w100"
                                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.CONTENT.SPANISH'"
                                                [group]="contentsFormGroup" [controlName]="'spanishContent'"
                                                [udeuFiles]="isManager ? [boud?.content?.spanishContent, boud?.content?.spanishGenerated] : [boud?.content?.spanishGenerated]"
                                                [editableFields]="editableContentFields"
                                                [mandatoryFields]="mandatoryContentFields" [maxFiles]="1"
                                                [smallSize]="true" [mimeTypes]="mimeTypes"></alden-attach-files>

                                            <alden-attach-files class="w100"
                                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.CONTENT.EUSKERA'"
                                                [group]="contentsFormGroup" [controlName]="'euskeraContent'"
                                                [udeuFiles]="isManager ? [boud?.content?.euskeraContent, boud?.content?.euskeraGenerated] : [boud?.content?.euskeraGenerated]"
                                                [editableFields]="editableContentFields"
                                                [mandatoryFields]="mandatoryContentFields" [maxFiles]="1"
                                                [smallSize]="true" [mimeTypes]="mimeTypes"></alden-attach-files>

                                            <alden-attach-files class="w100"
                                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.CONTENT.ENGLISH'"
                                                [group]="contentsFormGroup" [controlName]="'englishContent'"
                                                [udeuFiles]="isManager ? [boud?.content?.englishContent, boud?.content?.englishGenerated] : [boud?.content?.englishGenerated]"
                                                [editableFields]="editableContentFields"
                                                [mandatoryFields]="mandatoryContentFields" [maxFiles]="1"
                                                [smallSize]="true" [mimeTypes]="mimeTypes"></alden-attach-files>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="action-buttons" #actionDiv>
                                    <button *ngIf="i != 0" mat-raised-button matStepperPrevious color="primary">{{
                                        'ALDEN.STEPS_ACTIONS.PREVIOUS' | translate
                                        }}</button>
                                    <button *ngIf="i < stepsList.length-1" mat-raised-button matStepperNext
                                        color="primary">{{ 'ALDEN.STEPS_ACTIONS.NEXT'
                                        | translate }}</button>
                                </div>
                            </form>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-stepper>
    </ng-container>
</mat-dialog-content>